import { render, staticRenderFns } from "./indexHome.vue?vue&type=template&id=1a6a4096&scoped=true&"
import script from "./indexHome.vue?vue&type=script&lang=js&"
export * from "./indexHome.vue?vue&type=script&lang=js&"
import style0 from "./indexHome.vue?vue&type=style&index=0&id=1a6a4096&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a6a4096",
  null
  
)

export default component.exports